export const experiences = [
  {
    id: 1,
    title: "Full-Time Developer Web Developer Intern",
    company: "MusiTech",
    duration: "May 2024 - Nov 2024",
    description: [
      "Developed and designed various web projects including photography and college websites",
      "Led creation of interactive UIs with Framer Motion and Three.js animations",
      "Implemented version control and project management using Git for smooth collaboration",
      "Achieved 25% increase in client satisfaction through high-performance solutions"
    ],
    technologies: [
      "React",
      "Three.js",
      "Framer Motion",
      "Node.js",
      "MongoDB",
      "Express",
      "Tailwind CSS",
      "Git"
    ],
    testimonial: {
      name: "Sayuri Kamble",
      position: "Project Manager",
      text: "Excellent work on delivering high-performance web solutions with engaging user interfaces. The interactive animations and attention to detail significantly improved our user experience.",
      avatar: "https://media.licdn.com/dms/image/v2/C4E03AQGiiBMkSgQ5vQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1607193278001?e=1741824000&v=beta&t=JSFQfcxxyJDN6T0Q-HRzqilDfTXDKqh4ZQxrHMzLUf8"
    }
  },
];
